import { useParams } from "react-router-dom";
import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function OrganisationGroupsTeacherDetail() {
  const { id } = useParams();

  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <h2>Teacher Detail</h2>
        </div>
        <Row className="justify-content-center mt-4">
          <Col xxl={5} xl={6} lg={10}>
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="student-view">
                <img src={require("../../Assets/Images/girl.png")} alt="Teacher avatar" />
                <h2>Organisation Staff Member</h2>
                <p>Teacher detail route scaffold</p>
                <p>ID: {id}</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
